var t;!function(t){t[t.Left=0]="Left",t[t.Right=1]="Right"}(t||(t={}));export{t as EBubbleTextPosition};
//# sourceMappingURL=BubbleText.types.js.map
